import dayjs from 'dayjs'

const formatI18n = (value, format) => {
  if (value instanceof Date) {
    return dayjs(value).format(format)
  }

  return value
}

export { formatI18n }
